module.exports = __webpack_public_path__ + "c24e904e53d1c95ad38af36245bb88bf.mp3";